// DocumentCreator — zdieľaný modal na tvorbu KAMIR listiny (ústava 8.A).
// Použiteľný všade: Reklamácie · Dopyty · Zákazka→Dokumenty · Partneri · samostatný modul Listiny.
// Generuje PDF cez POST /api/listiny/generate (KAMIR hlavička + TP pätička + číslovanie).
import React, { useEffect, useState } from 'react'
import { Modal } from './Modal.jsx'
import { Btn, BtnGhost } from './Btn.jsx'
import { Input, Textarea } from './Input.jsx'
import { SearchableSelect } from './Ui.jsx'
import { useToast } from './Toast.jsx'
import { useAuth } from '../auth/AuthContext.jsx'
import { fetchAuth } from '../auth/fetchAuth.js'
import { COLORS, SPACE, RADIUS, TYPO, todayLocal } from '../theme.js'

const DOC_TYPES = ['Oznámenie', 'List', 'Stanovisko', 'Zápisnica', 'Sprievodný list', 'Výzva', 'Splnomocnenie', 'Čestné vyhlásenie', 'Potvrdenie', 'Reklamácia']

// Vzory dokumentov — všeobecná agenda. Splnomocnenie podľa § 31 a nasl. Občianskeho zákonníka (overené 2026-06-29).
// Údaje KAMIR: sídlo Tovarné 29, IČO 48029882, DIČ 2120047358, IČ DPH SK2120047358.
const VZORY = [
  { key: 'splnomocnenie', label: 'Splnomocnenie (plná moc)', docType: 'Splnomocnenie', mode: 'title', subject: 'SPLNOMOCNENIE', pozdrav: '',
    body: 'Splnomocniteľ:\nKAMIR s.r.o., so sídlom Tovarné 29, 094 01 Tovarné, IČO: 48029882, DIČ: 2120047358, IČ DPH: SK2120047358, zapísaná v Obchodnom registri OS Prešov, oddiel Sro, vložka č. [____], konajúca konateľom [meno konateľa]\n\nSplnomocnenec:\n[titul, meno a priezvisko], nar. [dátum], trvale bytom [ulica, PSČ a mesto], č. OP: [____]\n\nSplnomocniteľ týmto splnomocňuje splnomocnenca, aby ho zastupoval a v jeho mene vykonal tieto úkony:\n[ÚČEL / ROZSAH — napr. prevzal motorové vozidlo EČV [____] vrátane dokladov a kľúčov a podpísal preberací protokol]\na vykonal všetky úkony, ktoré s tým bezprostredne súvisia.\n\nSplnomocnenie platí do [dátum / do odvolania] a riadi sa § 31 a nasl. zákona č. 40/1964 Zb. Občiansky zákonník v znení neskorších predpisov.\nPozn.: úradné overenie podpisu splnomocniteľa nie je vždy povinné; pri prevode nehnuteľnosti (návrh na vklad do katastra) je povinné.\n\n.............................                    .............................\n   splnomocniteľ — KAMIR s.r.o.                          splnomocnenec' },
  { key: 'cestne', label: 'Čestné vyhlásenie', docType: 'Čestné vyhlásenie', mode: 'title', subject: 'ČESTNÉ VYHLÁSENIE', pozdrav: '',
    body: 'Dolupodpísaný/á [meno a priezvisko], nar. [dátum], bytom [adresa], (za KAMIR s.r.o. ako konateľ — ak relevantné)\n\nčestne vyhlasujem, že:\n[OBSAH VYHLÁSENIA — napr. údaje uvedené v ... sú pravdivé a úplné]\n\nToto vyhlásenie robím dobrovoľne a som si vedomý/á právnych následkov nepravdivého čestného vyhlásenia.\n\nV [mieste], dňa [dátum]' },
  { key: 'vyzva', label: 'Výzva na úhradu (upomienka)', docType: 'Výzva', mode: 'vec', subject: 'Výzva na úhradu faktúry č. [____]', pozdrav: 'S pozdravom',
    body: 'Dovoľujeme si Vás upozorniť, že v našej evidencii máme neuhradenú faktúru:\n\nčíslo faktúry: [____]\nsuma: [____] €\ndátum splatnosti: [____]\n\nZdvorilo Vás vyzývame na úhradu uvedenej sumy v lehote do [____] dní od doručenia tejto výzvy na účet [IBAN].\n\nV prípade, že platba bola medzitým uhradená, považujte túto výzvu za bezpredmetnú. Pri neuhradení si vyhradzujeme právo uplatniť úrok z omeškania, prípadne pohľadávku vymáhať právnou cestou.' },
  { key: 'potvrdenie', label: 'Potvrdenie o prevzatí', docType: 'Potvrdenie', mode: 'title', subject: 'POTVRDENIE O PREVZATÍ', pozdrav: '',
    body: 'Týmto potvrdzujem, že dňa [dátum] som prevzal/a:\n[predmet prevzatia — napr. doklady / kľúče / vozidlo / materiál ...]\n\nOdovzdal: [meno]\nPrevzal: [meno]\n\nV [mieste], dňa [dátum]' },
  { key: 'reklamacia', label: 'Reklamácia dodávateľovi', docType: 'Reklamácia', mode: 'vec', subject: 'Reklamácia — [predmet]', pozdrav: 'S pozdravom',
    body: 'Týmto si uplatňujeme reklamáciu na základe dodávky / faktúry č. [____] zo dňa [____].\n\nPredmet reklamácie:\n[popis vady / nedostatku]\n\nŽiadame o [riešenie — napr. výmenu / opravu / zľavu / vrátenie peňazí] v zákonnej lehote.' },
]
const todayISO = () => todayLocal()
const fmtDate = (iso) => { const p = String(iso || '').split('-'); return p.length === 3 ? `${+p[2]}.${+p[1]}.${p[0]}` : (iso || '') }

const lbl = { fontSize: 11, fontWeight: 700, color: COLORS.muted, marginBottom: 4, display: 'block' }
const fld = { width: '100%', padding: '8px 10px', border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.sm, fontSize: 13, boxSizing: 'border-box', fontFamily: 'inherit' }

export default function DocumentCreator({ open, onClose, context = {}, onGenerated }) {
  const toast = useToast()
  const { user } = useAuth()
  const [users, setUsers] = useState([])
  const [busy, setBusy] = useState(null)

  const [recipient, setRecipient] = useState('')
  const [nasaZn, setNasaZn] = useState('')
  const [vasaZn, setVasaZn] = useState('')
  const [miesto, setMiesto] = useState('Prešov')
  const [datum, setDatum] = useState(todayISO())
  const [docType, setDocType] = useState('Oznámenie')
  const [mode, setMode] = useState('vec')          // 'vec' = Vec: ... | 'title' = veľký nadpis
  const [subject, setSubject] = useState('')
  const [body, setBody] = useState('')
  const [pozdrav, setPozdrav] = useState('S pozdravom')
  const [podpis, setPodpis] = useState('')
  const [images, setImages] = useState([])
  const [imgBusy, setImgBusy] = useState(false)
  const [diaryOpen, setDiaryOpen] = useState(false)
  const [projects, setProjects] = useState([])
  const [selProj, setSelProj] = useState('')

  // načítaj používateľov pre výber podpisu (default = prihlásený)
  useEffect(() => {
    if (!open) return
    fetchAuth('/api/users').then(r => r.ok ? r.json() : []).then(list => {
      const arr = Array.isArray(list) ? list : []
      setUsers(arr)
      const me = arr.find(u => u.id === user?.id || u.username === user?.username)
      setPodpis(p => p || me?.display_name || user?.display_name || arr[0]?.display_name || '')
    }).catch(() => setPodpis(p => p || user?.display_name || ''))
  }, [open])

  useEffect(() => {
    if (!open) return
    setSelProj('')
    if (context.projectId) return
    fetchAuth('/api/projects').then(r => r.ok ? r.json() : []).then(d => { const arr = Array.isArray(d) ? d : (d.projects || d.rows || []); setProjects(arr) }).catch(() => {})
  }, [open])

  // predvyplň z kontextu (adresát / vaša značka / vec / telo)
  useEffect(() => {
    if (!open) return
    if (context.recipient != null) setRecipient(context.recipient)
    if (context.vasaZnacka != null) setVasaZn(context.vasaZnacka)
    if (context.nasaZnacka != null) setNasaZn(context.nasaZnacka)
    if (context.vec != null) { setSubject(context.vec); setMode('vec') }
    if (context.title != null) { setSubject(context.title); setMode('title') }
    if (context.body != null) setBody(context.body)
    if (context.docType) setDocType(context.docType)
    if (context.miesto != null) setMiesto(context.miesto)
    if (context.pozdrav != null) setPozdrav(context.pozdrav)
    if (context.podpis != null) setPodpis(context.podpis)
  }, [open])

  // Auto-vyplň ADRESÁTA z objednávateľa zákazky (Mirko 2026-06-29): firma / osoba / ulica+číslo / PSČ mesto
  useEffect(() => {
    if (!open || !context.projectId || context.recipient != null) return
    let on = true
    ;(async () => {
      try {
        const p = await fetchAuth('/api/projects/' + encodeURIComponent(context.projectId)).then(r => r.ok ? r.json() : null)
        const cid = p && (p.customerId || p.customer_id)
        if (!cid) return
        const c = await fetchAuth('/api/customers/' + encodeURIComponent(cid)).then(r => r.ok ? r.json() : null)
        if (!c || !on) return
        const lines = [c.name, c.contact, c.address].map(x => String(x || '').trim()).filter(Boolean)
        if (lines.length) setRecipient(prev => prev && prev.trim() ? prev : lines.join('\n'))
      } catch (_) {}
    })()
    return () => { on = false }
  }, [open, context.projectId])

  // Formátovanie bodov (Mirko 2026-06-29): jednotné číslovanie / odrážky / zrušiť
  const stripFmt = (l) => l.replace(/^\s*(\d+[.)]\s+|[•\-*]\s+)/, '')
  const numberLines = () => { let n = 0; setBody(body.split('\n').map(l => { const t = stripFmt(l).trim(); if (!t) return ''; n++; return n + '. ' + t }).join('\n')) }
  const bulletLines = () => setBody(body.split('\n').map(l => { const t = stripFmt(l).trim(); return t ? '• ' + t : '' }).join('\n'))
  const clearFmt = () => setBody(body.split('\n').map(l => stripFmt(l)).join('\n'))
  // Vzor dokumentu (všeobecná agenda) — predvyplní typ + text, premenné v [hranatých] dopíšeš
  const applyVzor = (key) => {
    const v = VZORY.find(x => x.key === key); if (!v) return
    if (body.trim() && !window.confirm('Prepísať text vzorom „' + v.label + '"?')) return
    setDocType(v.docType); setMode(v.mode || 'vec'); setSubject(v.subject || ''); setBody(v.body || ''); if (v.pozdrav != null) setPozdrav(v.pozdrav)
  }

  async function uploadImgs(files) {
    if (!files || !files.length) return
    setImgBusy(true)
    try {
      const added = []
      for (const f of files) {
        const fd = new FormData(); fd.append('file', f)
        const r = await fetchAuth('/api/listiny/upload-image', { method: 'POST', body: fd })
        const j = await r.json(); if (r.ok && j.url) added.push({ url: j.url, caption: '' })
      }
      setImages(a => [...a, ...added])
    } catch (e) { toast.error('Nahranie zlyhalo: ' + e.message) } finally { setImgBusy(false) }
  }
  async function generate(save) {
    if (!body.trim()) { toast.info('Doplň text dokumentu'); return }
    setBusy(save ? 'save' : 'pdf')
    try {
      const payload = {
        recipient, nasa_znacka: nasaZn, vasa_znacka: vasaZn,
        miesto, datum: fmtDate(datum),
        body, pozdrav, podpis,
        doc_type: docType,
        filename_base: (subject || docType || 'Listina'),
        save_to_project: !!save || !!context.edit_doc_id,
        edit_doc_id: context.edit_doc_id || null,
        project_id: (context.projectId || selProj || null),
        // rek_v3d — z ktorého záznamu list vzniká; archív si to zapíše a modul ho nájde späť
        source_module: context.source_module || '',
        source_id: context.source_id || '',
        images: images.map(im => ({ url: im.url, caption: im.caption })),
      }
      if (mode === 'title') payload.title = subject; else payload.vec = subject
      const r = await fetchAuth('/api/listiny/generate', { method: 'POST', body: JSON.stringify(payload) })
      const j = await r.json().catch(() => ({}))
      if (!r.ok || !j.ok) throw new Error(j.error || ('HTTP ' + r.status))
      window.open(j.url, '_blank')
      toast.success(save ? 'PDF uložené do dokumentov zákazky' : 'PDF vygenerované')
      onGenerated && onGenerated(j)
      if (save) onClose()
    } catch (e) { toast.error('Nepodarilo sa: ' + e.message) }
    setBusy(null)
  }

  const footer = (
    <>
      <BtnGhost onClick={() => guardClose()}>Zavrieť</BtnGhost>
      {context.projectId &&
        <Btn variant="add" onClick={() => generate(true)} disabled={!!busy}>
          {busy === 'save' ? 'Ukladám…' : 'Uložiť do zákazky'}
        </Btn>}
      <Btn variant="nav" onClick={() => generate(false)} disabled={!!busy}>
        {busy === 'pdf' ? 'Generujem…' : 'Vytvoriť PDF'}
      </Btn>
    </>
  )

  // DIRTY GUARD (ustava 53.1, 2026-07-16): rozpisana listina sa neda zavriet bez opytania
  const [gDlg, setGDlg] = useState(false)
  const gDirty = subject !== '' || body !== '' || recipient !== '' || images.length > 0
  const guardClose = () => { if (gDirty) setGDlg(true); else onClose() }

  if (!open) return null
  const half = { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: SPACE.md }
  return (
    <Modal open title="Vytvoriť dokument — KAMIR listina" onClose={guardClose} maxWidth={760} footer={footer}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: SPACE.md }}>
        <div style={{ background: COLORS.bgSoft, border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.sm, padding: '8px 10px' }}>
          <span style={lbl}>Vzor dokumentu <span style={{ fontWeight: 400, color: COLORS.muted }}>(predvyplní text, premenné v [hranatých zátvorkách] dopíšeš)</span></span>
          <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
            {VZORY.map(v => <button key={v.key} type="button" onClick={() => applyVzor(v.key)} style={{ fontSize: 12, padding: '5px 11px', border: `1px solid ${COLORS.line}`, background: '#fff', borderRadius: RADIUS.sm, cursor: 'pointer', fontFamily: 'inherit', color: COLORS.text }}>{v.label}</button>)}
          </div>
        </div>
        <div>
          <span style={lbl}>Adresát</span>
          <Textarea value={recipient} onChange={setRecipient} rows={3}
            placeholder={'Ing. Ján Novák\nStavebná spoločnosť s.r.o.\nHlavná 12\n080 01 Prešov'} />
        </div>

        {!context.projectId && <div>
          <span style={lbl}>Zákazka <span style={{ fontWeight: 400, color: COLORS.warn }}>(vyber zo zoznamu, ALEBO napíš číslo zákazky z MKsoft — naša značka bude číslo_NN)</span></span>
          <SearchableSelect value={selProj} onChange={setSelProj} allowCreate options={projects.map(p => ({ value: String(p.id), label: (p.name || p.id) + ' (' + p.id + ')' }))} placeholder="vyber zákazku alebo napíš číslo z MKsoft…" />
        </div>}

        <div style={half}>
          <div><span style={lbl}>Naša značka</span>
            <Input value={nasaZn} onChange={setNasaZn} placeholder={(context.projectId || selProj) ? ('automaticky: ' + (context.projectId || selProj) + '_NN') : 'KAMIR/2026/0042'} fullWidth /></div>
          <div><span style={lbl}>Vaša značka</span>
            <Input value={vasaZn} onChange={setVasaZn} placeholder="—" fullWidth /></div>
        </div>

        <div style={half}>
          <div><span style={lbl}>Miesto</span>
            <Input value={miesto} onChange={setMiesto} fullWidth /></div>
          <div><span style={lbl}>Dátum</span>
            <input type="date" value={datum} onChange={e => setDatum(e.target.value)} style={fld} /></div>
        </div>

        <div style={half}>
          <div><span style={lbl}>Typ dokumentu</span>
            <select value={docType} onChange={e => setDocType(e.target.value)} style={fld}>
              {DOC_TYPES.map(t => <option key={t} value={t}>{t}</option>)}
            </select></div>
          <div><span style={lbl}>Podpisuje</span>
            <select value={podpis} onChange={e => setPodpis(e.target.value)} style={fld}>
              {!users.some(u => u.display_name === podpis) && podpis && <option value={podpis}>{podpis}</option>}
              {users.map(u => <option key={u.id} value={u.display_name}>{(u.cele_meno || u.display_name) + (u.funkcia ? ' – ' + u.funkcia : '')}</option>)}
            </select></div>
        </div>

        <div>
          <span style={lbl}>Predmet — zobrazí sa ako: </span>
          <div style={{ display: 'flex', gap: SPACE.md, marginBottom: 6 }}>
            <label style={{ fontSize: 12, display: 'flex', gap: 4, alignItems: 'center', cursor: 'pointer' }}>
              <input type="radio" checked={mode === 'vec'} onChange={() => setMode('vec')} /> Vec: …
            </label>
            <label style={{ fontSize: 12, display: 'flex', gap: 4, alignItems: 'center', cursor: 'pointer' }}>
              <input type="radio" checked={mode === 'title'} onChange={() => setMode('title')} /> Veľký nadpis
            </label>
          </div>
          <Input value={subject} onChange={setSubject}
            placeholder={mode === 'title' ? 'OZNÁMENIE' : 'Oznámenie o stave realizácie diela'} fullWidth />
        </div>

        <div>
          <span style={lbl}>Text dokumentu <span style={{ fontWeight: 400, color: COLORS.muted }}>(odstavce oddeľ prázdnym riadkom — každý sa odsadí)</span></span>
          <div style={{ display: 'flex', gap: 6, margin: '4px 0 6px', flexWrap: 'wrap' }}>
            {[['1. Číslovať', numberLines], ['• Odrážky', bulletLines], ['Zrušiť formát', clearFmt]].map(([l, fn]) => (
              <button key={l} type="button" onClick={fn} title="aplikuje na riadky textu" style={{ fontSize: 12, padding: '3px 10px', border: `1px solid ${COLORS.line}`, background: COLORS.bgSoft, borderRadius: RADIUS.sm, cursor: 'pointer', fontFamily: 'inherit', color: COLORS.text }}>{l}</button>
            ))}
          </div>
          <Textarea value={body} onChange={setBody} rows={11}
            placeholder={'Týmto si Vás dovoľujeme informovať…\n\nDruhý odstavec…'} />
        </div>

        <div>
          <span style={lbl}>Obrázky <span style={{ fontWeight: 400, color: COLORS.muted }}>(max 2 na A4 stranu, s popisom)</span></span>
          <div style={{ display: 'flex', gap: SPACE.md, flexWrap: 'wrap', alignItems: 'center', marginBottom: 8 }}>
            <label style={{ ...fld, width: 'auto', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: 6, fontWeight: 600 }}>
              {imgBusy ? 'Nahrávam…' : '+ Z počítača'}
              <input type="file" accept="image/*" multiple disabled={imgBusy} onChange={e => uploadImgs(e.target.files)} style={{ display: 'none' }} />
            </label>
            <button type="button" onClick={() => setDiaryOpen(true)} style={{ ...fld, width: 'auto', cursor: 'pointer', fontWeight: 600 }}>Z denníka</button>
          </div>
          {images.length > 0 && <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            {images.map((im, i) => (
              <div key={i} style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                <img src={im.url} alt="" style={{ width: 54, height: 54, objectFit: 'cover', borderRadius: RADIUS.sm, border: `1px solid ${COLORS.line}` }} />
                <input value={im.caption} onChange={e => setImages(a => a.map((x, j) => j === i ? { ...x, caption: e.target.value } : x))} placeholder="Popis fotky…" style={{ ...fld, flex: 1 }} />
                <span onClick={() => setImages(a => a.filter((_, j) => j !== i))} style={{ cursor: 'pointer', color: COLORS.brand, fontWeight: 700, padding: '0 6px' }}>✕</span>
              </div>
            ))}
          </div>}
        </div>

        {diaryOpen && <DiaryPicker projectId={context.projectId} onClose={() => setDiaryOpen(false)} onPick={(picked) => { setImages(a => [...a, ...picked]); setDiaryOpen(false) }} />}
        <div style={half}>
          <div><span style={lbl}>Pozdrav</span>
            <Input value={pozdrav} onChange={setPozdrav} placeholder="S pozdravom" fullWidth /></div>
          <div style={{ alignSelf: 'end', fontSize: 11, color: COLORS.muted, paddingBottom: 8 }}>
            Hlavička (logo, ISO, firma) + pätička sa berú z Nastavení.
          </div>
        </div>
      </div>
      <Modal.DirtyConfirm open={gDlg}
        message="Rozpísaná listina — ulož/vygeneruj ju tlačidlami v okne, alebo zahoď."
        onSave={() => setGDlg(false)}
        onContinue={() => setGDlg(false)}
        onDiscard={() => { setGDlg(false); onClose() }} />
    </Modal>
  )
}


function DiaryPicker({ projectId, onClose, onPick }) {
  const [photos, setPhotos] = useState(null)
  const [sel, setSel] = useState(() => new Set())
  useEffect(() => {
    fetchAuth('/api/diary/photos-list' + (projectId ? '?project_id=' + encodeURIComponent(projectId) : ''))
      .then(r => r.ok ? r.json() : []).then(d => setPhotos(Array.isArray(d) ? d : [])).catch(() => setPhotos([]))
  }, [])
  const toggle = (p) => setSel(s => { const n = new Set(s); n.has(p.url) ? n.delete(p.url) : n.add(p.url); return n })
  const add = () => { const picked = (photos || []).filter(p => sel.has(p.url)).map(p => ({ url: p.url, caption: '' })); onPick(picked) }
  return (
    <Modal open title="Fotky z denníka" onClose={onClose} maxWidth={680}
      footer={<><BtnGhost onClick={onClose}>Zrušiť</BtnGhost><Btn variant="nav" onClick={add} disabled={!sel.size}>Pridať ({sel.size})</Btn></>}>
      {photos === null ? <div style={{ padding: SPACE.lg, color: COLORS.muted }}>Načítavam…</div>
        : photos.length === 0 ? <div style={{ padding: SPACE.lg, color: COLORS.muted, textAlign: 'center' }}>Žiadne fotky v denníku{projectId ? ' pre túto zákazku' : ''}.</div>
          : <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, maxHeight: '60vh', overflow: 'auto' }}>
            {photos.map((p, i) => { const on = sel.has(p.url); return (
              <div key={i} onClick={() => toggle(p)} title={(p.date || '') + ' · ' + (p.desc || '')} style={{ position: 'relative', cursor: 'pointer', border: on ? ('2px solid ' + COLORS.brand) : '2px solid transparent', borderRadius: RADIUS.sm }}>
                <img src={p.thumb} alt="" style={{ width: 92, height: 92, objectFit: 'cover', borderRadius: RADIUS.sm, display: 'block', opacity: on ? 1 : 0.85 }} />
                {on && <div style={{ position: 'absolute', top: 2, right: 2, width: 16, height: 16, borderRadius: '50%', background: COLORS.brand, color: '#fff', fontSize: 11, lineHeight: '16px', textAlign: 'center' }}>✓</div>}
              </div>) })}
          </div>}
    </Modal>
  )
}
